import React, { useEffect, useState, useN } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import { useHistory  } from 'react-router-dom';

import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, CommodityDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditCommodity = withRouter(props => {
  const history = useHistory();

  const classes = useStyles();
  const [commodityobj, setCommodityobj] = useState({});
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
  const [masters, setMasters] = useState({
    commodity : []
  });
 
  const snackbarCtx = React.useContext(SnackBarContext);

  const { sendNetworkRequest } = React.useContext(NetworkContext);


  async function fetchmasters()
  {
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {},false)
    let masterlangs = [
      {
        id: 0,
        name: "All"
      },
      ...languages.module
      
    ]
    setMasters({
      ...masters,
      languages : masterlangs
    })
  }
  async function updatecommodity(commodityinfo)
  {
    let commodities = await sendNetworkRequest('/admin/addcommodity', {}, commodityinfo,false)
   
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: commodities.status,
      msg: commodities.message,
      vertical: "top",
    });
    if(commodities.statusCode === 200)
    {
      history.goBack();

    }
    
  }
  async function fetchcommodityinfo(commodityid)
  {
    let commodities = await sendNetworkRequest('/admin/getcommodityinfo', {}, {commodity_id : commodityid},false)
     let commodity ={
      ...commodities.module
     }

    // if(commodities && commodities.parent_commodity)
    // {
    //   commodity = {
    //     value : commodities.parent_commodity.commodityID,
    //     label : commodities.parent_commodity.name
    //   }
    // }

   
    let comlanguages = [];
    let comlanguageids = commodities.module.languages
    if(masters && masters.languages)
    {
    masters.languages.forEach(element => {
      if(comlanguageids.includes(""+element.id))
      {
        comlanguages.push(element)
      }
    });
    commodity['language'] = comlanguages
  }
  let commodity_names = commodities.module.com_names
  commodity_names.forEach(element => {
    commodity['name-'+element.master_language.name] = element.name
  });
  commodity['status'] = commodities.module.status

    setCommodityobj(
      commodity
    )
  }
  useEffect(() => {
  //   var com_id = props.location.pathname.split('/')[2];
     fetchmasters()
    // if(com_id)
    // {
    //  fetchcommodityinfo(com_id);
    // }
    
   
  }, []);

  useEffect(() => {
       var com_id = props.location.pathname.split('/')[2];
       if(com_id)
       {
        fetchcommodityinfo(com_id);
        setViewtype(2)
       }
      
     
    }, [masters]);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
    <CommodityDetails usercontent={commodityobj} masters={masters} viewtype={viewtype} onSave={updatecommodity}/>
     
    </Page>
  );
});

export default EditCommodity;
